import { InstanceContext } from 'providers/InstanceProvider';
import { useContext } from 'react';

const useCurrentInstance = () => {
  const instanceInfo = useContext(InstanceContext);
  return { instanceInfo };
};

export default useCurrentInstance;
